<template>
    <div class="Views flex row-left-center">
        <div class="flex row-left-center Actions">
            <WIcon
                v-tooltip="{
                    content: $t('entities.actions.addView'),
                    placement: 'top',
                }"
                color="secondary"
                icon="plus"
                :size="16"
                class="Add"
                @click="$emit('onAddView')"
            />

            <Dropdown
                class="ViewsItemsDropdown"
                :options="normalizeListViews"
                :tooltip="{
                    content: $t('entities.actions.allViews'),
                    placement: 'top',

                }"
                :direction="dropdownDirection"
                icon="menu"
                iconColor="accent-blue"
                :iconSize="16"
                @onClick="$emit('onViewChanged', $event.key)"
            />
        </div>
        <div class="ViewsGradientsContainer">
            <div class="ViewsContainer">
                <div class="flex ViewsScrollContainer row-left-center">
                    <div
                        v-for="({ id, isDefault, data }) in views"
                        :key="id"
                        class="ViewTab flex row-left-center"
                    >
                        <WLink
                            v-if="data.label"
                            @click="$emit('onViewChanged', id)"
                        >
                            <WIcon
                                v-if="isDefault"
                                icon="star"
                                color="accent-blue"
                                :iconSize="16"
                            />
                            <WText
                                :color="value === id ? 'accent-blue' : ''"
                                :weight="value === id ? 'semi' : ''"
                                size="14"
                                ellipsis
                            >
                                {{ data.label }}
                            </WText>
                        </WLink>
                        <Dropdown
                            v-if="options"
                            :options="options"
                            :direction="dropdownDirection"
                            icon="chevron-down"
                            iconColor="accent-blue"
                            withCoordinates
                            class="TabDropdown"
                            @onClick="$emit('onOptionClicked', { action: $event.key, id})"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import { Dropdown } from '@/components'

export default {
    name: 'Views',
    components: {
        Dropdown,
    },
    props: {
        value: VueTypes.oneOfType([VueTypes.string, VueTypes.number]).isRequired,
        views: VueTypes.arrayOf(VueTypes.shape({
            id: VueTypes.oneOfType([VueTypes.string, VueTypes.number]),
            isDefault: VueTypes.bool.def(false),
            entity: VueTypes.string,
            data: VueTypes.object,
            createdAt: VueTypes.string,
        }).loose),
        options: VueTypes.arrayOf(VueTypes.shape({
            key: VueTypes.oneOfType([Number, String]).isRequired,
            label: VueTypes.oneOfType([Number, String]).isRequired,
        }).loose).isRequired,
        dropdownDirection: VueTypes.string.def('topRight'),
    },
    computed: {
        normalizeListViews () {
            return (this.views || []).map(({ id, isDefault, data }) => ({ key: id, label: data.label || '', iconRight: isDefault ? 'star' : '' }))
        },
    },
}
</script>
<style lang="scss" scoped>
.ViewsGradientsContainer {
    position: relative;
    width: 100%;
    &:after, &:before {
        content: '';
        pointer-events: none;
        position: absolute;
        top: 0;
        bottom: 0;
        width: 12px;
        z-index: 1;
    }
    &:after {
        background-image: linear-gradient(to right, transparent, rgba($white, 0));
        left: 0
    }
    &:before {
        background-image: linear-gradient(to left, transparent, rgba($white, 0));
        right: 0
    }
}
.ViewsContainer {
    position: relative;
    min-height: 26px;
    flex: 1;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: scroll;
    &::-webkit-scrollbar {
        display: none;
    }
    .ViewsScrollContainer {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
}

.ViewsItemsDropdown {
    &::v-deep {
        .Link {
            white-space: nowrap;
        }

        .Btn:hover .WIcon {
            color: $accent-blue;
            font-weight: bold;
        }
    }
}

.Views {
    .ViewTab {
        cursor: pointer;
        border-left: solid 1px $gray-05;
        padding-left: 12px;
        &:first-child {
            border: none;
            padding-right: 12px;
            .TabDropdown {
                display: none;
            }
        }
    }

    .Actions {
        padding-right: 8px;
        min-height: 22px;
        border-right: solid 1px $gray-05;
        .WIcon {
            cursor: pointer;
            padding: 0 4px;
            &:hover {
                color: $accent-blue;
                font-weight: bold;
            }
        }
    }

    .Add {
        margin-right: 4px;
    }
}

.TabDropdown {
    margin: 0 4px;

    &::v-deep {
        .Btn .WIcon {
            border-radius: $border-radius;
            line-height: 1.4;
            padding: 0 2px;
            display: inline-block;
            &:hover {
                background-color: $tertiary;
            }
        }
    }
}
</style>
